import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";
import { Link } from "../ui/link";
import { useConsent } from "./use-consent";

export function ConsentBanner() {
  const { consent, accept, reject } = useConsent();

  return (
    <Dialog open={consent === "undecided"} modal={false}>
      <DialogContent
        hideBackdrop
        anchor="bottom"
        showCloseButton={false}
        onEscapeKeyDown={(e) => e.preventDefault()}
        className="shadow-2xl"
      >
        <DialogHeader>
          <DialogTitle>Can we use cookies for anonymous analytics?</DialogTitle>
          <DialogDescription>It helps us make noma.to better for explorers like you.</DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col-reverse gap-3 items-center md:flex-row md:justify-between">
          <p className="text-xs text-muted-foreground text-center md:text-left">
            Some data is processed by <Link href="https://mixpanel.com/legal/privacy-policy/">Mixpanel</Link>{" "}
            <span className="whitespace-nowrap">(in the US).</span>
          </p>
          <div className="flex gap-3 w-full md:w-auto">
            <Button variant="outline" size="sm" className="flex-1 md:flex-none" onClick={reject}>
              No thanks
            </Button>
            <Button size="sm" className="flex-1 md:flex-none" onClick={accept}>
              Sure
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
